import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IInvoicingMoment } from "../../utils/types/models";

export default createEntityReducer<IInvoicingMoment>(Endpoint.InvoicingMoments, Endpoint.InvoicingMomentsList);
